import { Content, Header } from '../../libs/gs-component-right-rail';
import React, { useState } from 'react';

import { Body1 } from '@xo-union/tk-ui-typography';
import styles from './main.scss';
import { WeddingWebsiteQuery } from '../../generated/graphql';
import { DeleteWebsite } from './DeleteWebsite';
import { Privacy } from './Privacy';
import { Url } from './Url';
import { Visibility } from './Visibility';
import CVAlert from '../CVAlert';
import UpgradeURLCallout from '../PurchaseDomainModal/UpgradeURLCallout/UpgradeURLCallout';
import RegistryVisibility from './RegistryVisibility/RegistryVisibility';
import { Section } from './Section';

interface Props {
  data?: WeddingWebsiteQuery;
  loading: boolean;
  onClose: () => void;
  leftButtonOnClick?: () => void;
}

export const Main: React.FC<Props> = ({ data, loading, onClose, leftButtonOnClick }) => {
  const [erroring, setErroring] = useState(false);
  const preview = leftButtonOnClick !== undefined;

  const showVanityUrl = data?.weddingWebsite.purchaseDomain?.name
    ? data.weddingWebsite.purchaseDomain?.isExpired
      ? true
      : false
    : true;

  const isPublished = data?.weddingWebsite?.state === 'published';
  const showDelete = isPublished;

  if (!data?.weddingWebsite) {
    return null;
  }

  return (
    <>
      <Header leftButtonText={preview ? 'Back' : ''} leftButtonOnClick={leftButtonOnClick} onClose={onClose} as="h1">
        {preview ? 'Privacy & URL' : 'Settings'}
      </Header>
      <Content loading={loading} className={styles.settingsRailContent}>
        <div className={styles.settingsRailBody}>
          <CVAlert erroring={erroring} onTimeout={() => setErroring(false)} />
          <Section>
            <Body1 className={styles.header}>Privacy</Body1>
            <Visibility
              searchable={data.weddingWebsite.searchable}
              isPublished={isPublished}
              onError={() => setErroring(true)}
            />
            <Privacy
              pin={data.weddingWebsite.pin}
              pinProtect={data.weddingWebsite.pinProtect}
              isPublished={isPublished}
              onError={() => setErroring(true)}
            />
            <RegistryVisibility onError={() => setErroring(true)} />
          </Section>
          <Section>
            <Body1 className={styles.header}>Website URL</Body1>
            <Url showVanityUrl={showVanityUrl} vanityUrl={data.weddingWebsite.vanityUrl} />
            {showVanityUrl && <UpgradeURLCallout />}
          </Section>
          {showDelete && <DeleteWebsite />}
        </div>
      </Content>
    </>
  );
};
